import {Provider} from 'react-redux';
import {ColorPicker} from '@Components/color-picker';
import {ColorPickerPopover} from '@Components/color-picker-popover';
import {renderElement} from '@Utils/root-element.util';

window.PMW.mergePMW(window.PMW, {
  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {array} [opts.initialColor] containing one or more hex colors (one is required others are optional)
   * @param {number} [opts.initialType]
   * @param {bool} [opts.enableGradient=false] whether to show a dropdown for colorFillType
   * @param {bool} [opts.showPicker=false] whether to add pick from design option
   * @param {function} [opts.onColorChanging] callback on color changing
   * @param {function} [opts.onColorChanged] callback after color changed
   * @param {function} [opts.onClickColorPicker]
   * @param {object} [opts.dropdown]
   * @param {array} [opts.dropdown.options] array of {label, value} objects for dropdown
   * @param {function} [opts.dropdown.clickHandler] callback for when an option from dropdown is selected
   */
  renderColorPicker(containerElement: HTMLElement, opts: any) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <ColorPicker {...opts} />
      </Provider>
    );
  },

  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {string} [opts.color]
   * @param {string} [opts.screen] screen size info (small, big)
   * @param {string} [opts.placement] on which direction overlay should open (right, left, top, bottom)
   * @param {bool} [opts.showPicker=false] whether to add pick from design option
   * @param {function} [opts.onClickColorPicker]
   * @param {function} [opts.onColorChange]
   */
  openColorPickerPopover(containerElement: HTMLElement, opts: any = {}) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <ColorPickerPopover {...opts} />
      </Provider>
    );
  },
});
